<template>
    <div class="col-lg-12">
        <div class="card border-top-0">
            <div class="card-body personal-info">
                <form @submit.prevent="submitForm">
                    <div class="mb-4 d-flex align-items-center justify-content-between">
                        <h5 class="fw-bold mb-0 me-4">
                            <span class="d-block mb-2">Barınak Kartı Düzenle:</span>
                            <span class="fs-12 fw-normal text-muted text-truncate-1-line">Barınak kartlarını
                                buradan düzenleyebilirsiniz.</span>
                        </h5>
                        <div class="d-flex gap-2">
                            <button type="submit" class="btn btn-lg btn-light-brand bg-green text-white">Kaydet</button>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Barınak Adı: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="shelter.name"
                                    placeholder="Barınak Adı">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Barınak Konumu: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="shelter.location"
                                    placeholder="Barınak Konumu">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Açıklama: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="shelter.description"
                                    placeholder="Açıklama">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Bağlı Depo: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <select v-model="shelter.warehouse" class="form-control"
                                    data-select2-selector="shelter-warehouse" @click="fetchWarehouse">
                                    <option v-for="item in warehouse" :key="item.id" :value="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
export default {
    name: 'EditShelter',
    data() {
        return {
            shelter: {},
            warehouse: []
        }
    },
    async mounted() {
        const shelterId = this.$route.params.id;
        console.log(shelterId);
        if (shelterId) {
            await this.fetchShelter(shelterId);
        }
    },
    methods: {
        async fetchWarehouse() {
            try {
                const response = await this.$axios.get('warehouse/?active=True');
                this.warehouse = response.data.results;
            } catch (error) {
                Swal.fire('Hata', error, 'error');
            }
        },
        async fetchShelter(id) {
            try {
                const response = await this.$axios.get(`animal_shelter/${id}/`);
                this.shelter = response.data;
            } catch (error) {
                Swal.fire('Hata', error, 'error');
            }
        },
        async submitForm() {
            console.log('kayıttan önce shelter:', this.shelter);
            try {
                const response = await this.$axios.put(`animal_shelter/${this.shelter.id}/`, this.shelter);
                Swal.fire('Başarılı', 'Hayvan başarıyla güncellendi.', 'success');
                console.log(response);
                this.$router.push({ name: 'Shelters', params: { page: 1 } });

            } catch (error) {
                Swal.fire('Hata', error, 'error');
                console.log(error);
            }
        }
    }
}
</script>